// ResultTile.js
import React from 'react';

function ResultTile({ imageUrl, copy }) {
  return (
    <div className="result-tile">
      <p>{copy}</p>
      <img src={imageUrl} alt="Collab" />
    </div>
  );
}

export default ResultTile;
